import { render, staticRenderFns } from "./VehiclesListPage.vue?vue&type=template&id=7e85e4af&"
import script from "./VehiclesListPage.vue?vue&type=script&lang=ts&"
export * from "./VehiclesListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports